export const parseQueryParams = queryParamsStr =>
  queryParamsStr
    ? queryParamsStr.split('&').reduce((acc, cur) => {
        const [key, value] = cur.split('=');
        return {
          ...acc,
          [key]: value
        };
      }, {})
    : {};

export const stringifyQueryParams = (queryParams = {}) =>
  Object.keys(queryParams)
    .filter(key => queryParams[key])
    .map(key => `${key}=${queryParams[key]}`)
    .join('&');

export default {
  parseQueryParams,
  stringifyQueryParams
};
